import { DotsFileUploadRaw } from "dots-ui/dotsFileUpload";
import { useState } from "react";

interface IAvisFileUploadProps {
  name: string;
  disabled?: boolean;
  onChange?: (e: any) => void;
  allowedFormats?: string[];
}
export default function AvisFileUpload(props: Readonly<IAvisFileUploadProps>) {
  const { name, disabled, onChange, allowedFormats } = props;
  const [fileValue, setFileValue] = useState<File | undefined>();

  const allowedFileExtensions = allowedFormats
    ? allowedFormats.map((ext) => `.${ext}`)
    : [];

  return (
    <div title={fileValue?.name}>
      <DotsFileUploadRaw
        className="avis-file-upload"
        id={name}
        name={name}
        spacing="small"
        disabled={disabled}
        allowedFormats={allowedFileExtensions}
        hideClear
        onChange={(e) => {
          setFileValue(e.value);
          onChange && onChange(e.originalEvent);
        }}
        defaultLocale="lv"
        value={fileValue}
      />
    </div>
  );
}
